import { combineReducers } from 'redux';

import {
  SET_EXCEPTION_FILTERS,
  RESET_EXCEPTION_FILTERS,
  SET_EXCEPTION_GRID_SORT_CRITERIA,
} from './actionTypes';

const exceptionFiltersInitialState = {
  aggregatorID: '',
  payerID: '',
};

const exceptionGridSortCriteriaInitialState = {
  sortByColumn: '',
  sortDirection: '',
};

const exceptionFiltersReducer = (
  state = exceptionFiltersInitialState,
  { type = '', filters = { ...exceptionFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_EXCEPTION_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_EXCEPTION_FILTERS:
      return {
        ...state,
        ...exceptionFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const currentExceptionGridSortCriteriaReducer = (
  state = exceptionGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...exceptionGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_EXCEPTION_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const exceptionReducer = combineReducers({
  exceptionFilters: exceptionFiltersReducer,
  exceptionGridSortCriteria: currentExceptionGridSortCriteriaReducer,
});

export { exceptionReducer, exceptionFiltersInitialState, exceptionGridSortCriteriaInitialState };
